import axios from "axios";
import authStore from "./_stores/auth.store";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const httpClient = axios.create({
  //baseURL: "http://localhost:8000/api", // local
  //baseURL: "http://10.160.15.133:8000/api", // client azure
  //baseURL: "http://4.193.32.113:8000/api", // peracto azure
  //baseURL: "http://20.204.17.11:8000/api", // peracto azure
  //baseURL: "http://43.204.127.104:8000/api", // peracto Prod
  //baseURL: "http://162.44.205.22:3000/api", // client Internal
  //baseURL: "https://162.44.202.76:3000/api", // client External
  //baseURL: "https://uat-dst.iqvia.com:3003/api", // client UAT External
  //baseURL: "https://uat-dst.iqvia.com:3005/api", // client UAT External
  //baseURL: "https://dst.iqvia.com:3000/api", // client PROD External
  baseURL: BASE_URL,
  headers: {
    "Content-type": "application/json",
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
  },
});

httpClient.interceptors.request.use(
  function (config) {
    config.headers.common["x-auth-token"] = authStore.getState().auth_reducer.authToken;
    return config;
  },
  function (error) {
    console.error("axios.interceptors.request error => ", error);
    return Promise.reject(error);
  }
);

export default httpClient;
